import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialComponent } from '@rx-lib/ui';

@Component({
  selector: 'lib-home',
  standalone: true,
  imports: [CommonModule, SocialComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: []
})
export class HomeComponent {}
